import { FunctionClient } from '@juvare/platform-sdk-js/FunctionClient';
export function getToken() {
    return new FunctionClient()
        .executeFunction({
        functionName: 'pushToken',
    })
        .then((resp) => resp.result);
}
